import script from "./BaseTemplateItemShapeSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateItemShapeSetting.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateItemShapeSetting.vue?vue&type=style&index=0&id=d17954ac&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d17954ac"]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy});
